import { useDispatch } from 'react-redux';
import AddEditEntertainment from "./AddEditEntertainment";
import { useEffect, useState } from "react";
import { entertainmentList, useEntertainment, deleteEntertainment } from "../../Redux/Slices/entertainmentSlice";
import { Paginator } from 'primereact/paginator';
import toast from 'react-hot-toast';
import { FiChevronLeft, FiChevronRight, FiX } from "react-icons/fi";
import DeleteModal from "../../Components/DeleteModal";

const Entertainment = () => {
    const dispatch = useDispatch();
    const entertainmentData = useEntertainment();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [limit, setLimit] = useState(14);
    const [first, setFirst] = useState(1);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);
    const [isGalleriaOpen, setIsGalleriaOpen] = useState(false);
    const [galleryImages, setGalleryImages] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    const handleOpenDialog = (row) => {
        setSelectedRowData(row);
        setIsDialogOpen(true);
    }

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setSelectedRowData(null);
        getEntertianmentListFun();
    };

    const handleDeleteClick = (id) => {
        setIdToDelete(id);
        setIsDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        try {
            const response = await dispatch(deleteEntertainment({ entertainmentid: idToDelete || "" })).unwrap();
            if (response.IsSuccess) {
                toast.success('Banner deleted successfully');
                getEntertianmentListFun();
            } else {
                toast.error(response?.Message || 'Failed to delete banner');
            }
        } catch (error) {
            toast.error(error?.message || 'Failed to delete banner');
        } finally {
            setIsDeleteModalOpen(false);
            setIdToDelete(null);
        }
    };

    const getEntertianmentListFun = async (event = {}) => {
        let pageNo = event?.page + 1;

        if (event?.rows) {
            setLimit(event?.rows);
        }
        setFirst(event.first);
        const payload = {
            page: pageNo || 1,
            limit: event?.rows || 14,
        };
        try {
            await dispatch(entertainmentList(payload)).unwrap();
        } catch (error) {
            toast.error(error || "Something went wrong...!");
        }
    }

    useEffect(() => {
        setTimeout(() => {
            getEntertianmentListFun();
        }, 500);
    }, []);

    return (
        <>
            <div className="p-8">
                <div className="flex flex-wrap justify-between items-center mb-4">
                    <h2 className="text-24 font-semibold text-gray-800">Advertisement Banner</h2>
                    <button
                        className="btn flex justify-center items-center space-x-1 sm:w-auto w-full sm:mt-0 mt-2"
                        onClick={() => handleOpenDialog()}>
                        <span className="flex-shrink-0 group cursor-pointer">
                            <svg className="group-hover:text-primary transition-colors" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.0003 4.16602V15.8327M4.16699 9.99935H15.8337"
                                    stroke="currentColor"
                                    strokeWidth="1.67"
                                    strokeLinecap="round"
                                    strokeLinejoin="round" />
                            </svg>
                        </span>
                        <span>Add Photos</span>
                    </button>
                </div>

                <div className="flex flex-wrap -mx-2.5">
                    {entertainmentData?.Data?.docs?.length > 0 ? (
                        entertainmentData.Data.docs.map((data, index) => (
                            <div key={index} className="w-[calc(100%/2)] md:w-[calc(100%/4)] lg:w-[calc(100%/5)] xl:w-[calc(100%/7)] p-2">
                                <div className="bg-white rounded-2xl overflow-hidden relative">
                                    <div className="h-40 relative">
                                        {data?.banner && Array.isArray(data.banner) && data.banner.length > 0 ? (
                                            <div
                                                className="w-full h-full cursor-pointer"
                                                onClick={() => {
                                                    setGalleryImages(data.banner);
                                                    setActiveIndex(0);
                                                    setIsGalleriaOpen(true);
                                                }}
                                            >
                                                <img
                                                    src={data.banner[0]}
                                                    className="w-full h-full object-cover"
                                                    alt={`Banner ${index + 1}`}
                                                />
                                            </div>
                                        ) : (
                                            <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                                                <span className="text-gray-500">No Image</span>
                                            </div>
                                        )}
                                        <div className="absolute top-2 right-2 flex gap-2 z-10">
                                            <button
                                                onClick={() => handleOpenDialog(data)}
                                                className="bg-white text-primary rounded-md w-8 h-8 flex items-center justify-center"
                                            >
                                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </button>
                                            <button
                                                onClick={() => handleDeleteClick(data?._id)}
                                                className="bg-white text-primary rounded-md w-8 h-8 flex items-center justify-center"
                                            >
                                                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M19 7L18.1327 19.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224C6.81296 21 5.94208 20.1891 5.86732 19.1425L5 7M10 11V17M14 11V17M15 7V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V7M4 7H20"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="p-3 bg-white border-t border-gray-100">
                                        <div className="flex flex-col gap-1">
                                            <div className="flex justify-between items-center">
                                                <span className="text-sm text-gray-500 font-medium font-semibold">From Date:-</span>
                                                <span className="text-sm font-semibold text-gray-800">
                                                    {data?.fromDate ? new Date(data.fromDate).toLocaleDateString('en-GB') : 'N/A'}
                                                </span>
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <span className="text-sm text-gray-500 font-medium font-semibold">To Date:-</span>
                                                <span className="text-sm font-semibold text-gray-800">
                                                    {data?.toDate ? new Date(data.toDate).toLocaleDateString('en-GB') : 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="w-full bg-white">
                            <div className="w-full flex justify-center p-5">
                                <div className="max-w-8xl w-full rounded-2xl p-10 mx-auto bg-gray-100">
                                    <strong className="block text-xl lg:text-2xl text-center">No data</strong>
                                    <span className="block lg:text-lg text-center text-gray-500">Please add Data</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {
                    entertainmentData?.Data?.docs.length > 0 &&
                    <Paginator
                        className="justify-end mt-5 lg:mt-8"
                        first={first || 1}
                        rows={limit}
                        totalRecords={entertainmentData?.Data?.totalDocs}
                        rowsPerPageOptions={[14, 28, 42]}
                        onPageChange={getEntertianmentListFun}
                    />
                }
            </div >
            {isDialogOpen && (
                <AddEditEntertainment
                    isOpen={isDialogOpen}
                    onClose={handleCloseDialog}
                    getEntertianmentListFun={getEntertianmentListFun}
                    rowData={selectedRowData}
                />
            )
            }
            <DeleteModal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={confirmDelete}
            />

            {/* Image Preview Modal */}
            {isGalleriaOpen && (
                <div className="fixed inset-0 z-[10000] bg-black/95 flex flex-col items-center justify-center p-4">
                    <button
                        onClick={() => setIsGalleriaOpen(false)}
                        className="absolute top-5 right-5 text-white bg-white/10 hover:bg-white/20 p-2 rounded-full z-[10001]"
                    >
                        <FiX size={32} />
                    </button>

                    <div className="relative w-full max-w-5xl h-[80vh] flex items-center justify-center">
                        {galleryImages.length > 1 && (
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveIndex(prev => (prev === 0 ? galleryImages.length - 1 : prev - 1));
                                }}
                                className="absolute left-0 md:-left-12 text-white bg-white/10 hover:bg-white/20 p-4 rounded-full z-[10001]"
                            >
                                <FiChevronLeft size={40} />
                            </button>
                        )}

                        <img
                            src={galleryImages[activeIndex]}
                            className="max-w-full max-h-full object-contain"
                            alt="Preview"
                        />

                        {galleryImages.length > 1 && (
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveIndex(prev => (prev === galleryImages.length - 1 ? 0 : prev + 1));
                                }}
                                className="absolute right-0 md:-right-12 text-white bg-white/10 hover:bg-white/20 p-4 rounded-full z-[10001]"
                            >
                                <FiChevronRight size={40} />
                            </button>
                        )}
                    </div>

                    <div className="mt-8 text-white font-bold bg-white/10 px-6 py-2 rounded-full">
                        {activeIndex + 1} / {galleryImages.length}
                    </div>
                </div>
            )}
        </>
    )
}

export default Entertainment;